import {useDebounce} from 'presentation/hooks';
import {useQueryParams} from 'presentation/pages';
import {useEffect, useRef, useState} from 'react';
import {UseDebounceSearchType} from './types';

export function useDebounceSearch({timeDebounce = 500}: UseDebounceSearchType) {
	const {SEARCH_PARAMS, clearSearch} = useQueryParams();
	const {query} = SEARCH_PARAMS;

	const [searchValueState, setSearchValueState] = useState(query || '');

	const latestQueryRef = useRef(query);

	const [debouncedQueryFunc, abortDebounce] = useDebounce(() => {
		const currentQuery = latestQueryRef.current;
		if (currentQuery.length > 2) {
			setSearchValueState(currentQuery);
		}
	}, timeDebounce);

	const clearSearchParams = () => {
		setSearchValueState('');
		clearSearch();
	};

	useEffect(() => {
		latestQueryRef.current = query;
	}, [query]);

	return {
		searchValueState,
		debouncedQueryFunc,
		clearSearchParams,
		abortDebounce,
	};
}
